import * as React from 'react';
export const LUSvg = React.forwardRef(function LUSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 6h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M14.933 10V6H16v4h-1.067ZM0 6h1.067v4H0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M0 12.4V10h16v2.4c0 .884-.682 1.6-1.524 1.6H1.524C.682 14 0 13.284 0 12.4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M16 3.6V6H0V3.6C0 2.716.682 2 1.524 2h12.952C15.318 2 16 2.716 16 3.6Z',
      }),
    ),
  );
});
LUSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LU = {
  category: 'flag',
  colorable: false,
  name: 'LU',
  svg: LUSvg,
};
